// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :host {
    main {
        padding-top: \$header-height + \$sub-navbar-height;
        -webkit-overflow-scrolling: touch;

        @media (max-width: \$screen-md-bottom) {
            padding-bottom: \$footer-height;
        }

        @media print {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
} */`, "",{"version":3,"sources":["webpack://./src/app/U2000_workspace/U2000_workspace/U2000_workspace.component.scss"],"names":[],"mappings":"AAGA;;;;;;;;;;;;;;GAAA","sourcesContent":["@import \"../../U2000_style/U2000_style-variables\";\n@import \"../../U2000_style/U2000_style-mixins\";\n\n/* :host {\n    main {\n        padding-top: $header-height + $sub-navbar-height;\n        -webkit-overflow-scrolling: touch;\n\n        @media (max-width: $screen-md-bottom) {\n            padding-bottom: $footer-height;\n        }\n\n        @media print {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
